module.exports = __webpack_public_path__ + "img/21.8ff252f2.jpg";